// import "../styles.css";
export default {
  "ui:title": "",
  "ui:description": "",
  display_name: {
    "ui:title": "Display Name",
    "ui:placeholder": "ex: westfield",
  },
  mall: {
    "ui:placeholder": "ex: westfield les 4 temps",
    "ui:widget": "MallsSelectWidget",
  },
  retailer: {
    "ui:placeholder": "ex: Zara",
    "ui:widget": "RetailersSelectWidget",
  },

  "ui:submitButtonOptions": {
    norender: true,
  },
};
